import PropTypes from 'prop-types';
import { get } from 'core/libs/lodash';

import MarkdownWrapper from 'core/components/MarkdownWrapper';
import Avatar from 'core/components/Avatar';

import { resolveScopedStyles } from 'core/utils/styled-jsx';

import styles from './index.styl';


export default function Opinion(block, parentProps) {
  const { attributes } = block;
  const {
    theme: {
      colors: {
        active1,
      },
      controls: {
        vikontOpinion,
      },
    },
  } = parentProps;

  const body = get(attributes, 'body');
  const name = get(attributes, 'author.attributes.name');
  const job = get(attributes, 'author.attributes.job_title');
  const image = get(attributes, 'author.attributes.avatar.attributes.versions.original');

  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .${styles.body}
          margin-bottom ${vikontOpinion.body.marginBottom}
          padding-left ${vikontOpinion.body.paddingLeft}
          font-style ${vikontOpinion.bodyFontStyle}
          &:before
            background ${active1}
            width ${vikontOpinion.bodyBefore.width}
            left 0
      `}</style>
    </scope>
  );

  return (
    <div className={'opinion'}>
      <style jsx>{`
        .opinion
          max-width ${vikontOpinion.opinion.maxWidth}
          width ${vikontOpinion.opinion.width}
          padding ${vikontOpinion.opinion.padding}

        .${styles.job}
          font ${vikontOpinion.job.font}

        .name
          font ${vikontOpinion.name.font}
          margin-bottom ${vikontOpinion.name.marginBottom}

        .authorImage
          margin-right ${vikontOpinion.authorImage.marginRight}
      `}
      </style>
      {body && (
        <MarkdownWrapper className={scope.wrapClassNames(styles.body)}
          interitemSpacing={20}
        >
          {body}
        </MarkdownWrapper>
      )}
      <div className={styles.author}>
        {image && (
          <div className={'authorImage'}>
            <Avatar
              src={image}
              size={vikontOpinion.authorImage.size}
              isCircular
            />
          </div>
        )}
        <div className={'info'}>
          {name && (
            <div className={'name'}>
              {name}
            </div>
          )}
          {job && (
            <div className={styles.job}>
              {job}
            </div>
          )}
        </div>
      </div>
      <scope.styles />
    </div>
  );
}

Opinion.propTypes = {
  block: PropTypes.object,
  parentProps: PropTypes.object,
  ctx: PropTypes.object,
};
